/**
 * AgencyEntry — /agency
 *
 * Legacy entry point kept for backward-compatible deep links.
 * Immediately redirects authenticated agency users to /agency/dashboard,
 * and unauthenticated users to /agency/login.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AGENCY_JWT_KEY = 'agency_jwt';

function hasValidAgencyToken() {
  const token = localStorage.getItem(AGENCY_JWT_KEY);
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem(AGENCY_JWT_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

const AgencyEntry = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (hasValidAgencyToken()) {
      navigate('/agency/dashboard', { replace: true });
    } else {
      navigate('/agency/login', { replace: true });
    }
  }, [navigate]);

  return null;
};

export default AgencyEntry;
